import { useState } from "react";
import { FaTrash } from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import { FaCirclePlus } from "react-icons/fa6";
import { useGetAssociationByIdQuery, useGetSubdivisionByAssociationIdQuery } from "../associationApi";
import AddSubdivisionForm from "./Modal/AddSubdivisionForm";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import ModalButton from "../../../../components/common/form/ModalButton";
import { useDeleteSubdivisionAssociationMutation } from "../../../data/subDivision/subDivisionApi";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";

const AssociationSubdivisionForm = () => {

    let { associationId } = useParams();
    const [showSubDivisionAddModal, setShowSubDivisionAddModal] = useState(false);
    const { data: subdivisionData } = useGetSubdivisionByAssociationIdQuery(associationId);
    const iconButtonStyle = "cursor-pointer text-md";
    const { data: associationData } = useGetAssociationByIdQuery(associationId)
    const [deleteSubdivisions, { isLoading }] = useDeleteSubdivisionAssociationMutation();

    const handleDelete = async (subdivisionId: string) => {
        if (subdivisionId) {
            await deleteSubdivisions({ associationId: associationId, subdivisionId: subdivisionId }).unwrap();
        }
    };
    return (
        <div className="bg-text-1 shadow-[0_3px_10px_#0003] text-sm mt-3 rounded-md">
            <div className="flex justify-between items-center border-b border-[rgba(0,0,0,0.1)] p-2">
                <h5 className="font-semibold text-surface-0">Subdivions ({subdivisionData?.length || 0})</h5>
                {hasPermission(["ASSOC-U"]) &&
                    <FaCirclePlus className={'text-highlight-0'} onClick={() => setShowSubDivisionAddModal(true)} />}

            </div>
            <div className={'p-2 max-h-[150px] overflow-auto scrollbar-hide'}>
                <table className="w-full bg-text-0 border-2 border-[rgba(0,0,0,0.1)]   ">
                    <thead className="border-b-2 border-[rgba(0,0,0,0.1)]">
                        <tr>
                            {[
                                "Name",
                                "Phase",
                                "Unit",
                                "Section",
                                "City",
                                "County",
                                ...(hasPermission(["ASSOC-U"]) ? ["Action"] : [])
                            ].map((heading) => (
                                <th key={heading} className="p-2 text-left font-medium border-b border-surface-5 text-left whitespace-nowrap">{heading}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {subdivisionData && subdivisionData.length > 0 ? (
                            subdivisionData.map((data: any) => (
                                <tr key={data.id}>
                                    <td className="p-2">
                                        {hasPermission(["SUBD-R"]) ? (
                                            <Link to={`/subdivisions/${data.id}`} className="text-highlight-4">
                                                {data?.subdivisionKey?.name || "-"}
                                            </Link>
                                        ) : (
                                            <span>{data?.subdivisionKey?.name || "-"}</span>
                                        )}
                                    </td>
                                    <td className="p-2">{data?.subdivisionKey?.phase || "-"}</td>
                                    <td className="p-2">{data?.subdivisionKey?.unit || "-"}</td>
                                    <td className="p-2">{data?.subdivisionKey?.section || "-"}</td>
                                    <td className="p-2">{data?.city || "-"}</td>
                                    <td className="p-2">
                                        {data?.county?.countyName},{data?.county?.state?.stateAbbreviation}
                                    </td>
                                    <td className="px-4 py-2">
                                        {hasPermission(["ASSOC-U"]) &&
                                            <ModalButton
                                                triggerButton={
                                                    <FaTrash className={iconButtonStyle} title={"Delete Subdivision"} />
                                                }
                                                modal={
                                                    <ConfirmationModal
                                                        show={true}
                                                        setShow={() => { }}
                                                        title={"Delete Subdivision"}
                                                        bodyMessage={"Are you sure you want to delete this Subdivision?"}
                                                        onSubmit={() => handleDelete(data.id)}
                                                        isLoading={isLoading}
                                                    />
                                                }
                                            />}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td className="py-2 text-gray-500 ">
                                    There are no subdivisions  to display
                                </td>
                            </tr>
                        )}
                    </tbody>

                </table>
            </div>
            {showSubDivisionAddModal &&
                <AddSubdivisionForm show={showSubDivisionAddModal} setShow={setShowSubDivisionAddModal}
                    state={associationData && associationData?.county?.state?.stateAbbreviation}
                    countyId={associationData && associationData?.county?.id} />}
        </div>

    );
};

export default AssociationSubdivisionForm;
